<template>
    <div class="protocal-box">
        <MenuList 
            :son_id="state.son_id" 
            :fater_id="state.fater_id"
            :title="state.son_title"
            @getDetail="getDetail" />
        <div class="protocal-content">
            <strong class="protocal-content-title">{{ state.son_title }}</strong>
            <div ref="editorBox"></div>
        </div>
    </div>
</template>

<script setup>
import MenuList from "@@/protocal/pro_menu.vue"

import { getprotocalFaterSonDetail } from "@/api/index"
import { reactive, onMounted, ref, nextTick } from "vue"
import { useRoute } from "vue-router";
import cont_match_reg from "@/utils/editor.js"

import { decodeEntities } from "@/utils/tools.js"
// import { observeVideo } from "md-base-tools/editor/gitvideo"

const editorBox = ref(null)
const state = reactive({
    son_id: '',
    fater_id: '',
    son_title: '',
    content: '',
})

const route = useRoute();
onMounted(() => {
    state.son_id = route.params.son_id
    state.fater_id = route.params.fater_id

    getDetail({fater_id: state.fater_id, son_id: state.son_id})
})

const getDetail = (params) => {
    state.fater_id = params.fater_id
    state.son_id = params.son_id
    getprotocalFaterSonDetail({
        fater_id: params.fater_id,
        son_id: params.son_id
    }).then(res => {
        if (res.status == 0) {
            state.son_title = res.data.son_title
            document.title = res.data.son_title
            let cont = res.data.content

            if (cont.indexOf('&gt;') > -1){
                cont = decodeEntities(cont)
            }

            editorBox.value.innerHTML = ""
            
            nextTick(() => {
                // 使用appendChild方式添加内容

                console.log('cont_match_reg(cont)------>',cont_match_reg(cont))

                editorBox.value.appendChild(cont_match_reg(cont))

            })
        } else {
            state.son_title = "未找到对应协议"
            document.title = "未找到对应协议"
            let cont = `<div><p><span style="font-family: 微软雅黑, 'Microsoft YaHei'">请检查链接是否正确</span></p></div>`
                if (cont.indexOf('&gt;') > -1){
                    cont = decodeEntities(cont)
                }

                editorBox.value.innerHTML = ""
            
            editorBox.value.appendChild(cont_match_reg(cont))
        }
    })
}

</script>

<style lang="scss">
.protocal-box {
    width: 1080px;
    margin: 40px auto;
    display: flex;
    .protocal-content {
        width: 0;
        flex: 1;
        line-height: 24px;
        font-size: 16px;
        &-title {
            display: block;
            font-size: 24px;
            line-height: 40px;
            padding-bottom: 10px;
            border-bottom: 1px solid #E8E8E8;
            margin-bottom: 36px;
        }
    }
    // .protocal-content-content {
    //     .p-padding span {
    //         font-family: PingFang SC-Regular, PingFang SC;
    //         font-size: 16px !important;
    //     }
    // }
}
</style>
